import { render, staticRenderFns } from "./Gestion.vue?vue&type=template&id=2124d1ee&scoped=true"
import script from "./Gestion.vue?vue&type=script&lang=js"
export * from "./Gestion.vue?vue&type=script&lang=js"
import style0 from "./Gestion.vue?vue&type=style&index=0&id=2124d1ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2124d1ee",
  null
  
)

export default component.exports